__turbopack_context__.v({
  "accordionItem": "mobileMenuLink-module-scss-module__bdv4GG__accordionItem",
  "accordionSlideOverwrite": "mobileMenuLink-module-scss-module__bdv4GG__accordionSlideOverwrite",
  "fadeIn": "mobileMenuLink-module-scss-module__bdv4GG__fadeIn",
  "fadeOut": "mobileMenuLink-module-scss-module__bdv4GG__fadeOut",
  "featured": "mobileMenuLink-module-scss-module__bdv4GG__featured",
  "groupHeader": "mobileMenuLink-module-scss-module__bdv4GG__groupHeader",
  "groupTitle": "mobileMenuLink-module-scss-module__bdv4GG__groupTitle",
  "mobileMenuLink": "mobileMenuLink-module-scss-module__bdv4GG__mobileMenuLink",
  "removeSublinkPadding": "mobileMenuLink-module-scss-module__bdv4GG__removeSublinkPadding",
  "scaleIn": "mobileMenuLink-module-scss-module__bdv4GG__scaleIn",
  "scaleOut": "mobileMenuLink-module-scss-module__bdv4GG__scaleOut",
  "section": "mobileMenuLink-module-scss-module__bdv4GG__section",
  "sectionDivider": "mobileMenuLink-module-scss-module__bdv4GG__sectionDivider",
  "sectionLabel": "mobileMenuLink-module-scss-module__bdv4GG__sectionLabel",
  "sectionsWrap": "mobileMenuLink-module-scss-module__bdv4GG__sectionsWrap",
  "sublink": "mobileMenuLink-module-scss-module__bdv4GG__sublink",
  "sublinkDescription": "mobileMenuLink-module-scss-module__bdv4GG__sublinkDescription",
  "sublinkTitle": "mobileMenuLink-module-scss-module__bdv4GG__sublinkTitle",
  "sublinks": "mobileMenuLink-module-scss-module__bdv4GG__sublinks",
  "zoomIn": "mobileMenuLink-module-scss-module__bdv4GG__zoomIn",
  "zoomOut": "mobileMenuLink-module-scss-module__bdv4GG__zoomOut",
});
